<script setup>

</script>

<template>
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="20" cy="20" r="20" fill="#376FFE"/>
    <g clip-path="url(#clip0_553_1021)">
      <path d="M27.8 30H12.2C11 30 10 29 10 27.8V16.7H11.8V27.8C11.8 28 12 28.2 12.2 28.2H27.8C28 28.2 28.2 28 28.2 27.8V14.7C28.2 14.5 28 14.3 27.8 14.3H24.2L21.6 11.8H16.7V10H22.3L25 12.5H27.8C29 12.5 30 13.5 30 14.7V27.8C30 29 29 30 27.8 30Z" fill="white"/>
      <path d="M11.8 15H10V10H15V11.8H11.8V15Z" fill="white"/>
      <path d="M20 26.3C17.4 26.3 15.3 24.2 15.3 21.6C15.3 19.1 17.4 17 20 17C22.6 17 24.7 19.1 24.7 21.7C24.7 24.2 22.6 26.3 20 26.3ZM20 18.7C18.4 18.7 17.1 20 17.1 21.6C17.1 23.2 18.4 24.5 20 24.5C21.6 24.5 22.9 23.2 22.9 21.6C22.9 20 21.6 18.7 20 18.7Z" fill="white"/>
      <path d="M13.6001 13.2V15H15.3001H17.2001H19.2001V13.2H13.6001Z" fill="white"/>
    </g>
    <defs>
      <clipPath id="clip0_553_1021">
        <rect width="20" height="20" fill="white" transform="translate(10 10)"/>
      </clipPath>
    </defs>
  </svg>
</template>

<style scoped lang="scss">

</style>
